import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';

// Controller
import OpportunityDetailsModalController from './opportunityDetailsModal.controller';
import template from './opportunityDetailsModal.html';

const moduleName = 'staff.dashboardScreen.opportunityDetailsModal';
let module = angular.module(moduleName, [
  uiModal
]);

module.controller('OpportunityDetailsModalController', OpportunityDetailsModalController);

module.factory('opportunityDetailsModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: OpportunityDetailsModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        opportunity: () => props.opportunity,
        staffUser: () => props.staffUser,
        modalClass: () => props.modalClass,
      }
    });
    return modal.result;
  };
}]);

export default module;

